import { useMutation, useQueryClient } from '@tanstack/react-query';
import { projectVolumesKeys } from '../../../../hooks/useProjectVolumes';
import { volumeDocumentKeys } from '../../../../hooks/useVolumeDocuments';
import { projectDataClient } from '../../../../lib/connect/clients';
export function useAddVolumeDocument() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input)=>{
            const response = await projectDataClient.addVolumeDocument({
                ...input,
                documentType: input.documentType ?? '',
                sourceAttachmentId: input.sourceAttachmentId ?? '',
                submissionFilename: input.submissionFilename ?? ''
            });
            return response.document;
        },
        onSuccess: (_doc, { projectId, volumeId })=>{
            queryClient.invalidateQueries({
                queryKey: volumeDocumentKeys.list(projectId, volumeId)
            });
            queryClient.invalidateQueries({
                queryKey: projectVolumesKeys.list(projectId)
            });
        }
    });
}
